// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/hooks/useFormattedDate.ts"
);
import.meta.hot.lastModified = "1693286121398.1501";
}
// REMIX HMR END

import { DateTime } from 'luxon';
import { useMemo } from 'react';

export const useFormattedDate = (
  date: string,
  formatOpts: Intl.DateTimeFormatOptions = DateTime.DATE_MED_WITH_WEEKDAY,
) => {
  return useMemo(() => formatDate(date, formatOpts), [date, formatOpts]);
};

export function formatDate(
  date: string,
  formatOpts: Intl.DateTimeFormatOptions = DateTime.DATE_MED_WITH_WEEKDAY,
) {
  return DateTime.fromISO(date, { setZone: true }).toLocaleString(formatOpts);
}
